/*
  Kahve Kavurma Merkezi - Kahve Temel Bilgileri
  Asset: assets/kkm-kitap.js
  Purpose: Shared progressive enhancements for the Online Store 2.0 education page.
*/

(function () {
  "use strict";

  var ROOT_SELECTOR = "#kkm-kitap, .kkm-kitap";
  var TOC_LINK_SELECTOR = 'a[href^="#"]';
  var ACTIVE_CLASS = "is-active";
  var READY_CLASS = "is-ready";
  var REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function getRoots(scope) {
    return toArray((scope || document).querySelectorAll(ROOT_SELECTOR));
  }

  function getHashTarget(link) {
    var hash = link.getAttribute("href");

    if (!hash || hash === "#") {
      return null;
    }

    try {
      return document.getElementById(decodeURIComponent(hash.slice(1)));
    } catch (error) {
      return null;
    }
  }

  function getHeaderOffset() {
    var stickyHeader = document.querySelector(".shopify-section-header-sticky, sticky-header, header[style*='position: sticky']");
    var height = stickyHeader ? stickyHeader.getBoundingClientRect().height : 0;

    return Math.max(72, Math.ceil(height + 24));
  }

  function setActiveLink(root, targetId) {
    var links = toArray(root.querySelectorAll(".kk-toc " + TOC_LINK_SELECTOR + ", .kk-toc-item[href^='#']"));

    links.forEach(function (link) {
      var linkHash = link.getAttribute("href");
      var isActive = linkHash === "#" + targetId;

      link.classList.toggle(ACTIVE_CLASS, isActive);

      if (isActive) {
        link.setAttribute("aria-current", "location");
      } else {
        link.removeAttribute("aria-current");
      }
    });
  }

  function enhanceAnchorNavigation(root) {
    var links = toArray(root.querySelectorAll(TOC_LINK_SELECTOR));
    var reduceMotion = window.matchMedia && window.matchMedia(REDUCED_MOTION_QUERY).matches;

    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        var target = getHashTarget(link);

        if (!target) {
          return;
        }

        event.preventDefault();

        var top = target.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset();

        window.scrollTo({
          top: top,
          behavior: reduceMotion ? "auto" : "smooth"
        });

        if (history.pushState) {
          history.pushState(null, "", link.getAttribute("href"));
        }

        target.setAttribute("tabindex", "-1");
        target.focus({ preventScroll: true });
        setActiveLink(root, target.id);
      });
    });
  }

  function observeSections(root) {
    var sectionTargets = toArray(root.querySelectorAll("[id].kk-chapter, [id].kk-section, [data-kk-section-id]"));

    if (!sectionTargets.length || !("IntersectionObserver" in window)) {
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var id = entry.target.id || entry.target.getAttribute("data-kk-section-id");

          if (entry.isIntersecting && id) {
            setActiveLink(root, id);
          }
        });
      },
      {
        rootMargin: "-28% 0px -62% 0px",
        threshold: 0.01
      }
    );

    sectionTargets.forEach(function (section) {
      observer.observe(section);
    });
  }

  function enhanceCollapsibles(root) {
    var controls = toArray(root.querySelectorAll("[data-kk-toggle]"));

    controls.forEach(function (control) {
      var targetId = control.getAttribute("aria-controls") || control.getAttribute("data-kk-toggle");
      var target = targetId ? document.getElementById(targetId) : null;

      if (!target) {
        return;
      }

      if (!control.hasAttribute("aria-expanded")) {
        control.setAttribute("aria-expanded", "false");
      }

      target.hidden = control.getAttribute("aria-expanded") !== "true";

      control.addEventListener("click", function () {
        var expanded = control.getAttribute("aria-expanded") === "true";

        control.setAttribute("aria-expanded", String(!expanded));
        target.hidden = expanded;
      });
    });
  }

  function enhanceScrollableTables(root) {
    var wrappers = toArray(root.querySelectorAll(".kk-table-wrap"));

    wrappers.forEach(function (wrapper) {
      if (!wrapper.hasAttribute("tabindex")) {
        wrapper.setAttribute("tabindex", "0");
      }

      if (!wrapper.hasAttribute("role")) {
        wrapper.setAttribute("role", "region");
      }
    });
  }

  function syncInitialHash(root) {
    if (!window.location.hash) {
      return;
    }

    var targetId = window.location.hash.slice(1);

    if (targetId) {
      setActiveLink(root, decodeURIComponent(targetId));
    }
  }

  function initRoot(root) {
    if (!root || root.dataset.kkmKitapReady === "true") {
      return;
    }

    root.dataset.kkmKitapReady = "true";
    root.classList.add(READY_CLASS);

    enhanceAnchorNavigation(root);
    observeSections(root);
    enhanceCollapsibles(root);
    enhanceScrollableTables(root);
    syncInitialHash(root);
  }

  function init(scope) {
    getRoots(scope).forEach(initRoot);
  }

  document.addEventListener("DOMContentLoaded", function () {
    init(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();